/**
 * Códigos de palet y de ubicación.
 *
 * Los lectores de códigos de barras USB "escriben" como un teclado. Si el lector está
 * configurado con distribución inglesa y el PC con española, los separadores llegan
 * cambiados (p. ej. "A-01-01" llega como "A'01'01"). Por eso:
 *  - Los códigos de palet son solo letras mayúsculas y dígitos.
 *  - Las búsquedas por código comparan la versión normalizada (sin separadores).
 * La normalización DEBE coincidir con la columna generada `locations.code_key`
 * (regexp_replace(upper(code), '[^A-Z0-9]', '', 'g')).
 */

export const PALLET_CODE_PREFIX = 'P';
export const PALLET_CODE_DIGITS = 8;

/** Caracteres permitidos en un código de ubicación. */
export const LOCATION_CODE_PATTERN = /^[A-Za-z0-9][A-Za-z0-9 ._/-]*$/;

export function normalizeScanCode(input: string): string {
  return input.toUpperCase().replace(/[^A-Z0-9]/g, '');
}

export function formatPalletCode(sequenceValue: number): string {
  return `${PALLET_CODE_PREFIX}${String(sequenceValue).padStart(PALLET_CODE_DIGITS, '0')}`;
}

/** Normaliza una referencia de cliente para búsquedas exactas (sin distinguir mayúsculas). */
export function normalizeClientReference(reference: string): string {
  return reference.trim().toUpperCase();
}

/**
 * Divide un texto con varias referencias (separadas por comas, punto y coma,
 * saltos de línea o espacios) en una lista sin duplicados, conservando el orden.
 */
export function parseReferenceList(text: string): string[] {
  const seen = new Set<string>();
  const result: string[] = [];
  for (const raw of text.split(/[\s,;]+/)) {
    const ref = raw.trim();
    if (!ref) continue;
    const key = normalizeClientReference(ref);
    if (seen.has(key)) continue;
    seen.add(key);
    result.push(ref);
  }
  return result;
}
